"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteDocuments = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _DocumentsTable = require("./DocumentsTable");
var _constants = require("../utils/constants");
var reducer = _interopRequireWildcard(require("../redux/reducers"));
var _sagas = require("../redux/sagas");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SiteDocumentsContent = () => {
  var _useSelector, _useSelector$UI, _tI$documents;
  /** @todo: add getActiveTranslationsInterfaceLocalizations in core */
  const tI = ((_useSelector = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterface)) === null || _useSelector === void 0 ? void 0 : (_useSelector$UI = _useSelector.UI) === null || _useSelector$UI === void 0 ? void 0 : _useSelector$UI.Localizations) || {};
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h5",
    sx: {
      fontWeight: 'bold',
      color: _constants.colors['main-color-cl-01'],
      marginBottom: 6
    }
  }, (_tI$documents = tI.documents) !== null && _tI$documents !== void 0 ? _tI$documents : /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    sx: {
      fontSize: 'inherit',
      width: 200
    }
  })), /*#__PURE__*/_react.default.createElement(_DocumentsTable.DocumentsTable, null));
};
const SiteDocumentsWrap = () => {
  (0, _paulCorePackage.useInjectStore)({
    key: _constants.packageKey,
    reducer,
    saga: _sagas.appSagas
  });
  return /*#__PURE__*/_react.default.createElement(SiteDocumentsContent, null);
};
exports.SiteDocuments = SiteDocumentsWrap;